import {useMutation, useQueryClient} from 'react-query'
import {KTIcon} from '../../../../../_metronic/helpers'
import {BASE_URL} from '../../../config'
import {Role} from '../_model'
import {ChangeEvent, FormEvent, useEffect, useState} from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import {handleAxiosError} from '../../../../utils/helperFunction/_helper'

type RoleFormProps = {
  selectedRole: Role | null
  refetch: () => void
  onReset: () => void
}

const CREATE_ROLE_URL = `${BASE_URL}/api/protect/createUserRole`
const UPDATE_ROLE_URL = `${BASE_URL}/api/protect/updateRole`

const RoleForm = ({selectedRole, refetch, onReset}: RoleFormProps) => {
  const queryClient = useQueryClient()
  const [rolename, setRolename] = useState('')

  const onRolenameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setRolename(value)
  }

  const {mutateAsync: roleSubmit} = useMutation({
    mutationFn: async () => {
      toast.loading('Processing..')
      if (selectedRole) {
        await axios.put(UPDATE_ROLE_URL, {idLevel: selectedRole.id_level, levelName: rolename})
      } else {
        await axios.post(CREATE_ROLE_URL, {levelName: rolename})
      }
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Successfully done')
      queryClient.invalidateQueries(['userRole'])
      refetch()
      setRolename('')
      onReset()
    },
    onError: (error: Error) => {
      console.log(error)
      const message = handleAxiosError(error)
      toast.dismiss()
      toast.error(message)
    },
  })

  const onSubmitRoleForm = async (e: FormEvent) => {
    e.preventDefault()

    try {
      await roleSubmit()
    } catch (error) {
      const message = handleAxiosError(error)
      toast.dismiss()
      toast.error(message)
      console.log(error)
    }
  }

  const reset = () => {
    setRolename('')
    onReset()
  }

  useEffect(() => {
    setRolename('')
    if (selectedRole) {
      setRolename(selectedRole.level_name)
    }
  }, [selectedRole])

  return (
    <div className='modal fade' tabIndex={-4} id='kt_modal_4'>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Role</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={onSubmitRoleForm}>
              <div className='fv-row mb-7'>
                <label className='fw-semibold fs-6 mb-2 required'>Role Name</label>

                <input
                  placeholder='Enter value'
                  type='text'
                  name='rolename'
                  className={`form-control form-control custom-input mb-3 mb-lg-0 ${
                    selectedRole && 'border-info'
                  }`}
                  value={rolename}
                  onChange={onRolenameChange}
                  autoComplete='off'
                  required
                />
              </div>

              <div className='mt-9 text-center'>
                <button
                  type='reset'
                  className='btn btn-light me-3'
                  onClick={reset}
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  Reset
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  disabled={!rolename}
                >
                  <span className='indicator-label'>{selectedRole ? 'Update' : 'Create'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoleForm
